export const ACTION = {
  CANCEL: 'CANCEL',
};
export const ACTIONS = Object.values(ACTION);
